<template>
  <div>
    <PageTable :disabled="disabled" />
  </div>
</template>
<script>
import PageTable from './table'
export default {
  name: 'transport-pendingOrderBatch',
  components: { PageTable },
  props: { disabled: { type: Boolean, default: false } },
}
</script>
